export default __webpack_public_path__ + "static/media/H_Helicoptero.1a8313d5.mp3";